import { Link } from "gatsby";
import React from "react";

import { ArrowIcon } from "../Icons";
import * as styles from "./styles.module.css";

const Button = ({ to, children, direction = "right", disabled, target }) => (
  <Link
    className={`${styles.button} ${
      direction === "right" ? styles.right : styles.left
    } ${disabled ? styles.disabled : null}`}
    to={to}
    target={target}
  >
    <span style={{ marginRight: "0.5rem" }}>
      {direction === "left" ? (
        <ArrowIcon color="#fff" direction="left" />
      ) : null}
    </span>
    {children}
    <span style={{ marginLeft: "0.5rem" }}>
      {direction === "right" ? <ArrowIcon color="#fff" /> : null}
    </span>
  </Link>
);

export default Button;
